import { NavLink, useLocation } from "react-router-dom";
import { Home, Link2, FileText, MapPin, Database, Plus, MessageSquare, Settings, X, LogOut } from "lucide-react";
import { Button } from "../ui/button";

const navItems = [
  { path: "/", icon: Home, label: "Dashboard" },
  { path: "/links", icon: Link2, label: "Linki" },
  { path: "/offers", icon: FileText, label: "Oferty" },
  { path: "/map", icon: MapPin, label: "Mapa" },
  { path: "/filters", icon: Database, label: "Filters" },
  { path: "/quick-add", icon: Plus, label: "Szybkie dodanie" },
  { path: "/messages", icon: MessageSquare, label: "Wiadomości" },
  { path: "/settings", icon: Settings, label: "Ustawienia" },
];

const Sidebar = ({ isOpen, setIsOpen, onLogout }) => {
  useLocation();

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}

      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-card border-r flex flex-col
        transform transition-transform duration-200
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-testid="sidebar">
        <div className="h-14 flex items-center justify-between px-4 border-b">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Home className="w-4 h-4 text-primary-foreground" />
            </div>
            <span className="font-bold text-lg font-['Outfit']">Unity</span>
          </div>
          <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setIsOpen(false)}>
            <X className="w-5 h-5" />
          </Button>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `
                flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm
                transition-all duration-200
                ${isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                }
              `}
              onClick={() => setIsOpen(false)}
            >
              <item.icon className="w-4 h-4" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t">
          <Button
            variant="ghost"
            className="w-full justify-start gap-2 text-muted-foreground"
            onClick={onLogout}
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            Wyloguj
          </Button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
